<template>
  <div class="nav-header">
    <el-menu :default-active="activeIndex" class="nav-menu" :class="[style]" mode="horizontal">
      <el-menu-item index="0">
        <a :href="Options.links.website" :title="$root.lang.navbar.home"><img class="josh-logo" src="@/assets/public/logo.png"></a>
      </el-menu-item>
      <!-- <el-menu-item index="joshvm" class="pull-right">
          <a href="#" target="_blank">{{ $root.lang.navbar.joshvm }}</a>
      </el-menu-item> -->
      <el-menu-item index="community" class="pull-right">
        <a target="_blank" :href="Options.links.community">
          <span>{{ $root.lang.navbar.community }}</span>
        </a>
      </el-menu-item>
      <el-menu-item index="develop" class="pull-right">
        <router-link to="/develop/base">
          <span>{{ $root.lang.navbar.developer }}</span>
        </router-link>
      </el-menu-item>
      <el-menu-item index="document" class="pull-right">
        <router-link to="/base">
          <span>{{ $root.lang.navbar.document }}</span>
        </router-link>
      </el-menu-item>
      <!-- <el-dropdown class="lang-select pull-right" @command="changeLang">
        <span class="el-dropdown-link">
          {{ activeLang }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :command="index" :key="index" v-for="(item,index) in lang">{{ item.name }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->
      <!-- <el-menu-item index="2" class="pull-right"><a href="#">{{ $root.lang.navbar.store }}</a></el-menu-item>
      <el-menu-item index="1" class="pull-right"><a href="#">{{ $root.lang.navbar.developer }}</a></el-menu-item> -->
    </el-menu>
  </div>
</template>

<script>
import lang from '@/options/lang'
export default {
  data () {
    return {
      activeIndex: this.index,
      activeLang: '',
      lang: lang,
      username: null,
      style: this.className
    }
  },
  props: {
    index: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    }
  },
  watch: {
    '$route': function (value) {
      var parent = value.meta.parent
      this.activeIndex = parent
      window.scrollTo({ 
        top: 0
      })
    }
  },
  created() {
    var parent = this.$route.meta.parent
    this.activeIndex = parent
    /*var lang = this.$root.getStorage('lang')
    this.activeLang = ((lang) ? this.lang[lang].name : '简体中文')*/
  },
  methods: {
    changeLang(value) {
      this.$root.setStorage('lang',value)
      window.location.reload()
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '@/css/style.scss';
$font-color: #909399;
.nav-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #ffffff;
  border-top: 4px solid $color-blue;
  border-bottom: solid 1px #e6e6e6;
  z-index: 9;
  .nav-menu {
    padding: 0 2%;
    margin: 0 auto;
    width: 96%;
  }
  /*.auto-width {
    width: auto;
  }*/
  .el-menu-item {
    padding: 0;
    margin: 0 20px;
  }
  .josh-logo {
    height: 26px;
  }
  .lang-select {
    display: block;
    margin: 0 15px;
    height: 60px;
    line-height: 60px;
    color: $font-color;
    cursor: pointer;
  }
  .lang-select:hover {
    color: inherit;
  }
  .el-dropdown-link {
    display: block!important;
  }
  .el-menu.el-menu--horizontal {
    border-bottom: 0;
  }
  a {
    display: block;
    height: 100%;
    text-decoration: none;
  }
}
.el-dropdown-menu a {
  display: block;
  height: 100%;
  color: inherit;
  text-decoration: none;
}

</style>



// WEBPACK FOOTER //
// src/components/public/NavBar.vue